import { render, staticRenderFns } from "./ThreeNumber.vue?vue&type=template&id=6470db5c&"
import script from "./ThreeNumber.vue?vue&type=script&lang=js&"
export * from "./ThreeNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports